/** SUNTRONIX ONE — Experience preferences (ONE VIBE).
 *  Per-user animation / sound / density / theme, cached in localStorage for
 *  instant application and synced to the backend (/api/experience/prefs).
 */
const KEY = "st.experience.prefs";

export const DEFAULT_PREFS = {
  animation: "on",        // on | reduced | off
  sound: false,
  density: "comfortable", // comfortable | compact
  theme: "system",        // system | light | dark
  moments: true,
};

export function getPrefs() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) return { ...DEFAULT_PREFS, ...JSON.parse(raw) };
  } catch { /* ignore */ }
  return { ...DEFAULT_PREFS };
}

export function savePrefs(prefs) {
  try { window.localStorage.setItem(KEY, JSON.stringify(prefs)); } catch { /* ignore */ }
  applyPrefs(prefs);
}

/** Resolve the animation level, honouring the OS reduced-motion setting. */
export function effectiveAnimation(prefs = getPrefs()) {
  if (prefs.animation === "off") return "off";
  const osReduced = typeof window !== "undefined" &&
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (osReduced || prefs.animation === "reduced") return "reduced";
  return "on";
}

/** Apply density + theme to the document root (idempotent, cheap). */
export function applyPrefs(prefs = getPrefs()) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.dataset.density = prefs.density || "comfortable";
  root.dataset.animation = effectiveAnimation(prefs);
  let dark = prefs.theme === "dark";
  if (prefs.theme === "system") {
    dark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  root.classList.toggle("dark", !!dark);
}
